import type { TaskStatus, TaskPriority, TaskSource, Task } from '@/types/database';

export type { TaskStatus, TaskPriority, TaskSource, Task };

export interface TaskWithClient extends Task {
  client_name: string | null;
}

export const TASK_STATUS_LABELS: Record<TaskStatus, string> = {
  pending: 'Pendente',
  in_progress: 'Em andamento',
  completed: 'Concluída',
  cancelled: 'Cancelada',
};

export const TASK_PRIORITY_LABELS: Record<TaskPriority, string> = {
  low: 'Baixa',
  normal: 'Normal',
  high: 'Alta',
  urgent: 'Urgente',
};

export const TASK_PRIORITY_CLASSES: Record<TaskPriority, string> = {
  low: 'bg-muted text-muted-foreground border-border',
  normal: 'bg-primary/10 text-primary border-primary/20',
  high: 'bg-amber-100 text-amber-700 border-amber-200',
  urgent: 'bg-expense/10 text-expense border-expense/20',
};

export const TASK_SOURCE_LABELS: Record<TaskSource, string> = {
  manual: 'Manual',
  playbook: 'Playbook',
  onboarding: 'Onboarding',
  system: 'Sistema',
};

/**
 * Buckets do "Meu Dia": atrasadas, hoje, próximas 48h, depois.
 * Usado pelo agrupador puro (testável sem React).
 */
export type TaskBucket = 'overdue' | 'today' | 'next_48h' | 'later' | 'no_due_date';

export const BUCKET_ORDER: TaskBucket[] = ['overdue', 'today', 'next_48h', 'later', 'no_due_date'];

export const BUCKET_LABELS: Record<TaskBucket, string> = {
  overdue: 'Atrasadas',
  today: 'Hoje',
  next_48h: 'Próximas 48h',
  later: 'Depois',
  no_due_date: 'Sem data',
};
